import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map, filter } from 'rxjs/operators';
import { LogoutUserSuccess } from '../../auth/action-creators';
import { LOGOUT_USER_SUCCESS } from '../../auth/actions';
import { rudderReset } from '@webapp/utils/rudderstack/init';
import { resetBeaconIdentity } from '@webapp/utils/helpscout/indentify';

export const resetOnLogoutEpic = (action$: Observable<LogoutUserSuccess>) =>
  action$.pipe(
    ofType(LOGOUT_USER_SUCCESS),
    map(() => {
      if (window.analytics) {
        window.analytics.reset();
      }
      rudderReset();
      resetBeaconIdentity()
    }),
    filter(() => false)
  );
